module.exports = __webpack_public_path__ + "img/ico-delete-gray.c4464f60.svg";